import {
  EdgeStyleBase,
  IEdge,
  IRenderContext,
  PolylineEdgeStyle,
  Stroke,
  SvgVisual,
  Visual,
} from '@ardoq/yfiles';
import { disablePointerEvents } from './util';
import { getHighlightColor } from 'tabview/graphComponent/getHighlightColor';

const createPolylineEdgeStyle = (edge: IEdge, edgeThickness: number) =>
  new PolylineEdgeStyle({
    stroke: new Stroke(getHighlightColor(edge.tag), edgeThickness),
  });
export class EdgeSelectionStyle extends EdgeStyleBase {
  constructor(private edgeThickness: number) {
    super();
  }
  protected override createVisual(
    context: IRenderContext,
    edge: IEdge
  ): Visual | null {
    const polylineEdgeStyle = createPolylineEdgeStyle(edge, this.edgeThickness);
    const result = polylineEdgeStyle.renderer
      .getVisualCreator(edge, polylineEdgeStyle)
      .createVisual(context);
    if (result instanceof SvgVisual) {
      disablePointerEvents(result);
    }
    return result;
  }
  protected override updateVisual(
    context: IRenderContext,
    oldVisual: Visual,
    edge: IEdge
  ): Visual | null {
    const polylineEdgeStyle = createPolylineEdgeStyle(edge, this.edgeThickness);
    const result = polylineEdgeStyle.renderer
      .getVisualCreator(edge, polylineEdgeStyle)
      .updateVisual(context, oldVisual);
    if (result instanceof SvgVisual) {
      disablePointerEvents(result);
    }
    return result;
  }
}
